import React from "react";
import { createStyles, makeStyles, useMediaQuery, useTheme } from "@material-ui/core";
import { trackMainNavEvent } from "../analytics";
var useStyles = makeStyles(function (_a) {
    var _b;
    var breakpoints = _a.breakpoints;
    return createStyles({
        logo: (_b = {
                height: "100%"
            },
            _b[breakpoints.up("md")] = {
                marginRight: "40px",
            },
            _b),
        link: {
            height: "100%",
            display: "flex",
            alignItems: "center",
            outline: "none",
            userSelect: "none",
        },
    });
});
var AstroLogo = function (_a) {
    var logo = _a.logo;
    var theme = useTheme();
    var styles = useStyles();
    var isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    var width = isDesktop ? "76px" : "57px";
    var height = isDesktop ? "32px" : "24px";
    return (React.createElement("div", { className: styles.logo },
        React.createElement("a", { href: logo.url, className: styles.link, id: "headerAstroLogo", onClick: function () { return trackMainNavEvent("Astro Logo", logo.url); } },
            React.createElement("img", { src: logo.image, alt: logo.name, width: width, height: height }))));
};
export default AstroLogo;
